import type { ReactNode } from "react";

export interface DataListItem {
  label: string;
  value: ReactNode;
  key?: string;
}

interface DataListProps {
  items: DataListItem[];
  variant?: "plain" | "inverse";
  columns?: 1 | 2 | 3;
}

/**
 * Lista de dados rotulados (dt/dd). Extraída na Fase 3 a partir de duas implementações duplicadas:
 * a carteirinha institucional (fundo escuro, caixas destacadas) e a ficha do associado (fundo claro,
 * sem caixa). "plain" e "inverse" são só a skin; a estrutura semântica é a mesma nos dois casos.
 */
export function DataList({ items, variant = "plain", columns = 2 }: DataListProps) {
  const className = ["data-list", `data-list--${variant}`, `data-list--cols-${columns}`].join(" ");

  return (
    <dl className={className}>
      {items.map((item, index) => (
        <div key={item.key ?? `${item.label}-${index}`}>
          <dt>{item.label}</dt>
          <dd>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
